import React, { useEffect } from 'react'
import { reaction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@material-ui/core/styles'

import { useStore } from '../hooks/storeHook'
import { useMyProductColumns } from '../hooks/myProductHooks'

import { MyServerTable } from './MyServerTable'
import { MyProductsTableHead } from './Tables/MyProductsTableHead'

import { MyProductState } from '../server/mpsklad_core/Models/MyProductState'

export const MyProductsTable =
  observer(() => {
    const classes = useStyles()

    const {productStore} = useStore()
    const myProducts = productStore.myProducts

    const myProductColumns = useMyProductColumns()

    useEffect(() =>
        reaction(
          () => productStore.storeMountState,
          () => {
            if (productStore.storeMountState) {
              myProducts.reload()
            }
          }),
      [productStore, myProducts])

    useEffect(() =>
        reaction(() => productStore.myStateTab,
          () => {
            if (productStore.myStateTab !== MyProductState.FromMarketplace) {
              myProducts.loadWithPageReset()
            }
          }),
      [productStore, myProducts])

    return (
      <MyServerTable
        hideTopPagination
        classes={classes}
        table={myProducts}
        columns={myProductColumns.visible}
        HeadComponent={MyProductsTableHead}
        labelNoRows="Товаров нет"
        labelNotFound="Товары не найдены"
        labelRowsPerPage="Товаров на странице:"
      />
    )
  })

const useStyles =
  makeStyles(
    (/*theme*/) => ({
      paper: {
        minWidth: 1280,
        boxShadow: 'unset'
      },
      tableContainer: {
        width: 'calc(100vw - 300px)'
      },
      table: {
        minWidth: 1580,
        fontSize: 12,
        color: '#5f5f5f'
      }
    }))
